/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-expressions */
import 'sharedStyles/styles.scss';
import 'config/polyfills';
import 'waypoints/lib/noframework.waypoints.min';
import { mouseEventPolyfill, polyfillArrayFind } from 'helpers/polyfills'; // eslint-disable-line
import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';

import modules from 'js/config';

const initModule = (el, module, disableif) => {
    if (disableif !== null && document.querySelector(disableif) !== null) {
        // null
        return;
    }
    return el === null || document.querySelector(el) !== null ? module() : null;
};

modules.forEach((k, i) => {
    try {
        // console.log(mod.el, document.querySelector(mod.el))
        initModule(modules[i].el || null, modules[i].module, modules[i].disableif || null);
    } catch (e) {
        console.log('init error', modules[i].module);
    }
});



// WEBPACK FOOTER //
// ./app/index.js